import { GeneralStyle } from '@website-builder/model/style/general-style';

export class ToTopStyle extends GeneralStyle {
  position = 'right';
  marginBottom = 20;
  marginRight = 20;
  marginLeft = 20;
  decoration = '';
  decorationColor = 'tb-icon-decoration-primary';
  color = '';
  size = 'tb-icon-medium';
  hoverColor = '';

  static normalize(styles: Partial<ToTopStyle>): ToTopStyle {
    const pureStyles = new ToTopStyle();

    pureStyles.position = styles.position ?? pureStyles.position;
    pureStyles.marginBottom = styles.marginBottom ?? pureStyles.marginBottom;
    pureStyles.marginRight = styles.marginRight ?? pureStyles.marginRight;
    pureStyles.marginLeft = styles.marginLeft ?? pureStyles.marginLeft;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.hoverColor = styles.hoverColor ?? pureStyles.hoverColor;

    return pureStyles;
  }
}
